import React, { useState } from 'react';

import MentorFormSearch from '@/components/mentor/MentorFormSearch';
import MentorList from '@/components/mentor/MentorList';
import MentorTopHeader from '@/components/mentor/MentorTopHeader';

const MentorManagementPage: React.FC = () => {
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <MentorTopHeader />
      <MentorFormSearch onSearch={() => setSearchTrigger((prev) => prev + 1)} />
      <MentorList searchTrigger={searchTrigger} />
    </>
  );
};

export default MentorManagementPage;
